import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Owned by G25 (plan.md S0), alongside search.tsx. Pathless-content layout for
 * the whole Reports screen group — 13 sub-pages (the hub + 12 §13 reports + the
 * products register) is too many for a persistent tab bar (unlike the smaller
 * screen groups' Tabs/Button-row layouts), so each screen carries its own
 * "back to hub" breadcrumb instead (features/reports/components/ReportPage.tsx). */
export const Route = createFileRoute('/_authenticated/reports')({
  component: () => <Outlet />,
});
